import { breakpoints } from '../../lib/constants';

export const getCurrentDevice = () => window.innerWidth <= breakpoints.tablet;

/** Creates query params object from search string. */
export const getQueryParams = (search: string) => {
  const searchParams = new URLSearchParams(search);
  return Object.fromEntries(searchParams);
};

export const purchaseDeflectionWording = "Please contact the administrator of your company's account to purchase";
